import { makeStyles } from '@material-ui/styles'

export const useClasses = makeStyles((theme) => ({
  root: {
    display: 'flex',
    overflowY: 'auto',
    gap: theme.spacing(5),
    flexDirection: 'column',
  },
  groupCollectionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  date: {
    lineHeight: 1.1,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.statement.group.color,
  },
  balanceLabel: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.statement.group.color,
  },
  balance: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.statement.group.color,
  },
}))
